import { render } from "./Index.vue?vue&type=template&id=0e20603b&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=0e20603b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e20603b"

export default script